import { generatePath } from "react-router-dom";

import { INVOICES_BASE_PATH_WITH_TAB_ID, PROJECT_DETAILS_PATH_WITH_TAB_ID } from "~/constants/appRoutes.ts";
import { InvoicePageTabId } from "~/modules/billing/utils/billingUtils.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";

export const validInvoiceDetailsNavigatedFromOrigins = {
	PROCESSED_INVOICES_INDEX: "index",
	UNPAID_INVOICES_INDEX: "unpaid",
	PROJECT_INVOICES: "project",
} as const;

export type ValidInvoiceDetailsNavigatedFromOrigin = typeof validInvoiceDetailsNavigatedFromOrigins[keyof typeof validInvoiceDetailsNavigatedFromOrigins];

export function getInvoiceDetailsBackPath(from?: ValidInvoiceDetailsNavigatedFromOrigin, projectId?: string): string {
	if (from === validInvoiceDetailsNavigatedFromOrigins.UNPAID_INVOICES_INDEX) {
		return generatePath(INVOICES_BASE_PATH_WITH_TAB_ID, { tabId: InvoicePageTabId.UNPAID });
	}

	if (from === validInvoiceDetailsNavigatedFromOrigins.PROCESSED_INVOICES_INDEX) {
		return generatePath(INVOICES_BASE_PATH_WITH_TAB_ID, { tabId: InvoicePageTabId.PROCESSED });
	}

	if (from === validInvoiceDetailsNavigatedFromOrigins.PROJECT_INVOICES && projectId) {
		return generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, {
			projectId,
			tabId: ProjectDetailsTabName.Invoices,
		});
	}

	return generatePath(INVOICES_BASE_PATH_WITH_TAB_ID, { tabId: InvoicePageTabId.Pending });

}